<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (piece) {
  <idt-common-styles-render [styles]="piece.settings?.styles">
    @let product = product$ | async;
    @if (product && product?.id) {
      <render-modal-panel
        aria-labelledby="add-to-cart-modal"
        #addToCartModal="render-modal-panel"
        [modalName]="'add-to-cart-modal-' + piece.id"
        [modalType]="renderByDevice.isMobile ? 'full' : 'notification'"
        [hasToShowCloseButton]="false"
        [addToBody]="renderByDevice.isMobile"
      >
        @if(addToCartModal.open) {
          <render-add-to-cart-modal
            [props]="addToCartModal.props$ | async">
          </render-add-to-cart-modal>
        }
      </render-modal-panel>
      <div
        class="single-product">
        @if (renderByDevice.isMobile && hasExtraImageEnabled) {
          @let imageData = getBothImages(product);
          @if (imageData) {
            @if (piece?.settings?.general) {
              <div
                cmsSwiper
                class="swiper-container"
                [config]="swiperConfig">
                <div class="swiper-wrapper">
                  @for (image of imageData; track trackByIdx($index)) {
                    @if (image && image.imageData) {
                      <div class="swiper-slide">
                        <render-link
                          [lang]="lang"
                          [link]="getProductLink(product, image.imageDetail)"
                          [piece]="piece"
                          (renderLinkEvent)="onProductClick(product)">
                          <img
                          alt="{{ (image.imageData.src! | getAltText | async) || product.longDescription || product.name || '' }}"
                          [lazySrc]="image.imageData"
                          (mouseenter)="onMainEnter()"
                          (mouseleave)="onMainLeave()"/>
                        </render-link>
                        @if (hasToDisplayProductCart) {
                          <render-product-purchase-options
                            [ngClass]="renderByDevice.isMobile ? 'product-sizes-mobile' : 'product-sizes'"
                            [product]="product"
                            [imageDetails]="imageDetails"
                            [country]="country"
                            [lang]="lang"
                            [piece]="piece"
                            [originInfoEvent]="settings.general.analytics?.origin || 'product-home'"
                            [providerInfoEvent]="settings.general.analytics?.provider || provider"
                            [strategyInfoEvent]="settings.general.analytics?.strategy || strategy"
                            [objectiveInfoEvent]="settings.general.analytics?.objective || objective">
                          </render-product-purchase-options>
                        }
                      </div>
                    }
                  }
                </div>
              </div>
            }
          }
        } @else {
          <div
            class="image-product"
            [ngClass]="{'has-product-cart': hasToDisplayProductCart}">
            <render-link
              [lang]="lang"
              [link]="getProductLink(product)"
              [piece]="piece"
              (renderLinkEvent)="onProductClick(product)"
            >
            @let imageData = getProductImageData(product);
            @if (hasToDisplayCustomImage && (settings.general.portraitImage?.image || settings.general.landscapeImage?.image)) {
              @let orientation = orientation$ | async;
              @if (imageData) {
                @if (orientation === 'landscape') {
                  @let customImage = getLandscapeImageSrc();
                  <img
                    alt="{{ (imageData.src! | getAltText | async) || product.longDescription || product.name || '' }}"
                    [lazySrc]="customImage"
                    [preRender]="!!settings.general.preloadImage"/>
                } @else {
                  @let customImage = getPortraitImageSrc();
                  <img
                    alt="{{ (imageData.src! | getAltText | async) || product.longDescription || product.name || '' }}"
                    [lazySrc]="customImage"
                    [preRender]="!!settings.general.preloadImage"/>
                }
              }
            } @else {
                @if (imageData) {
                  <img
                    alt="{{ (imageData.src! | getAltText | async) || product.longDescription || product.name || '' }}"
                    [lazySrc]="imageData"
                    (mouseenter)="onMainEnter()"
                    (mouseleave)="onMainLeave()"/>
                }
              }
            </render-link>
            <div class="product-data">
              @if (hasToDisplayInspirationalText && settings?.general?.inspirationalText) {
                <div class="product-name">
                  <render-wysiwyg
                    class="product-name"
                    [html]="settings.general.inspirationalText"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece">
                  </render-wysiwyg>
                </div>
              }
              @if (hasToDisplayProductName && product.name) {
                <div class="product-name">
                  <render-wysiwyg
                    class="product-name"
                    [html]="getProductName(product.name)"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece">
                  </render-wysiwyg>
                </div>
              }
              @if (hasToDisplayProductDescription && product.longDescription) {
                <div class="product-description">
                  <render-wysiwyg
                    [html]="getProductDescription(product.longDescription)"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece">
                  </render-wysiwyg>
                </div>
              }
              @if (hasToDisplayPrices) {
                <div class="product-price-container">
                  <render-product-prices
                    [product]="product"
                    [piece]="piece"
                    [customStyles]="settings?.general?.customStyles">
                  </render-product-prices>
                </div>
              }
            </div>
            @if (hasToDisplayProductCart) {
              <render-product-purchase-options
                #productSizesBlock
                [ngClass]="renderByDevice.isMobile ? 'product-sizes-mobile' : 'product-sizes'"
                [product]="product"
                [imageDetails]="imageDetails"
                [country]="country"
                [lang]="lang"
                [piece]="piece"
                [originInfoEvent]="settings.general.analytics?.origin || 'product-home'"
                [providerInfoEvent]="settings.general.analytics?.provider || provider"
                [strategyInfoEvent]="settings.general.analytics?.strategy || strategy"
                [objectiveInfoEvent]="settings.general.analytics?.objective || objective">
              </render-product-purchase-options>
            }
          </div>
        }

        @if (piece?.settings?.general?.productVariants?.length) {
          <div
            class="variants"
            [ngClass]="{'mobile-variant': renderByDevice.isMobile}">
            @for (variant of piece.settings!.general.productVariants; track trackByIdx($index)) {
              <render-link
                [lang]="lang"
                [link]="getProductLink(product, variant)"
                [piece]="piece"
                (renderLinkEvent)="onProductClick(product)">
                @let imageData = getProductImageData(product, variant, 48);
                @if (imageData) {
                  <img
                    alt="{{ (imageData.src! | getAltText | async) || product.longDescription || product.name || '' }}"
                    [lazySrc]="imageData"
                    (mouseenter)="onDetailEnter(product, variant)"
                    (mouseleave)="onDetailLeave()"/>
                }
              </render-link>
            }
          </div>
        }
      </div>
      <render-modal-panel
        aria-labelledby="product-size-modal"
        #productSizeModal="render-modal-panel"
        [modalName]="'size-selector-modal-' + piece.id"
        [modalType]="'full'"
        [hasToShowCloseButton]="false"
      >
        <render-product-sizes-modal
          [props]="productSizeModal.props$ | async"
          *ngIf="productSizeModal.open">
        </render-product-sizes-modal>
      </render-modal-panel>
    }
  </idt-common-styles-render>
}
